import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FiArrowLeft } from 'react-icons/fi';

const Namuna10Report = () => {
    const navigate = useNavigate();
    const [activeTab, setActiveTab] = useState('malak'); // 'malak', 'gav', 'ward'
    const [villageType, setVillageType] = useState('all'); // 'all', 'village'

    return (
        <div className="min-h-screen bg-gray-50 font-poppins">
            {/* Header */}
            <div className="bg-[#1e429f] text-white p-4 shadow-lg sticky top-0 z-10 flex items-center gap-4">
                <button 
                    onClick={() => navigate(-1)}
                    className="hover:bg-white/20 p-2 rounded-full transition-colors"
                >
                    <FiArrowLeft className="w-6 h-6" />
                </button>
                <h1 className="text-xl font-bold">पाणीपुरवठा नमुना नं. 10 रजिस्टर</h1>
            </div>

            <div className="max-w-5xl mx-auto p-4 md:p-8">
                <div className="bg-white rounded-lg shadow-lg overflow-hidden border border-gray-200">
                    
                    {/* Tabs */}
                    <div className="flex border-b border-gray-200">
                        <button 
                            className={`flex-1 py-3 text-center font-medium ${activeTab === 'malak' ? 'text-gray-800 border-b-2 border-gray-800 bg-gray-50' : 'text-gray-500 hover:text-gray-700'}`}
                            onClick={() => setActiveTab('malak')}
                        >
                            मालक
                        </button>
                        <button 
                            className={`flex-1 py-3 text-center font-medium ${activeTab === 'gav' ? 'text-gray-800 border-b-2 border-gray-800 bg-gray-50' : 'text-gray-500 hover:text-gray-700'}`}
                            onClick={() => setActiveTab('gav')}
                        >
                            गाव
                        </button>
                        <button 
                            className={`flex-1 py-3 text-center font-medium ${activeTab === 'ward' ? 'text-gray-800 border-b-2 border-gray-800 bg-gray-50' : 'text-gray-500 hover:text-gray-700'}`}
                            onClick={() => setActiveTab('ward')}
                        >
                            वार्ड
                        </button>
                    </div>

                    <div className="p-6 min-h-[300px]">
                        {/* Tab Content */}
                        
                        {activeTab === 'malak' && (
                            <div className="space-y-6 animate-fade-in-up">
                                <div className="border border-blue-400 rounded-lg p-6">
                                    <div className="grid grid-cols-1 md:grid-cols-12 gap-4 items-center mb-4">
                                        <div className="md:col-span-2 text-gray-700 font-medium">प्रकार निवडा</div>
                                        <div className="md:col-span-8">
                                            <select className="w-full p-2 border border-blue-300 rounded focus:border-blue-500 focus:outline-none">
                                                <option>धारकाचे नाव</option>
                                            </select>
                                        </div>
                                        <div className="md:col-span-2">
                                            <button className="w-full bg-[#1e429f] hover:bg-[#1a3680] text-white py-2 rounded font-medium">
                                                दाखवा
                                            </button>
                                        </div>
                                    </div>
                                    
                                    <div className="grid grid-cols-1 md:grid-cols-12 gap-4 items-start mb-4">
                                        <div className="md:col-span-2 text-gray-700 font-medium pt-2">धारकाचे </div>
                                        <div className="md:col-span-10">
                                            <textarea 
                                                className="w-full h-24 p-2 border border-blue-300 bg-gray-100 rounded resize-none focus:outline-none"
                                                readOnly
                                            ></textarea>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}

                        {activeTab === 'gav' && (
                             <div className="space-y-6 animate-fade-in-up">
                                <div className="border border-blue-400 rounded-lg p-6">
                                    <div className="flex items-center gap-6 mb-6">
                                        <label className="flex items-center gap-2 cursor-pointer">
                                            <input 
                                                type="radio" 
                                                name="villageType" 
                                                checked={villageType === 'all'}
                                                onChange={() => setVillageType('all')}
                                                className="w-5 h-5 text-gray-800 focus:ring-gray-800"
                                            />
                                            <span className="font-medium">सर्व</span>
                                        </label>
                                        <label className="flex items-center gap-2 cursor-pointer">
                                            <input 
                                                type="radio" 
                                                name="villageType" 
                                                checked={villageType === 'village'}
                                                onChange={() => setVillageType('village')}
                                                className="w-5 h-5 text-gray-800 focus:ring-gray-800"
                                            />
                                            <span className="font-medium">गावानुसार</span>
                                        </label>
                                        
                                        <div className="flex items-center gap-2 ml-4 flex-1">
                                            <span className="font-medium whitespace-nowrap">गाव निवडा</span>
                                            <select className="w-full p-2 border border-blue-300 rounded focus:border-blue-500 focus:outline-none">
                                                <option>इनाम धामणी</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                             </div>
                        )}

                        {activeTab === 'ward' && (
                            <div className="space-y-6 animate-fade-in-up">
                                 <div className="border border-blue-400 rounded-lg p-6">
                                    <div className="mb-4">
                                        <label className="flex items-center gap-2 cursor-pointer">
                                            <input 
                                                type="checkbox" 
                                                className="w-4 h-4 border-gray-800 rounded focus:ring-gray-800"
                                            />
                                            <span className="text-gray-700 font-medium">सर्व निवडा</span>
                                        </label>
                                    </div>
                                    
                                    <table className="w-full border-collapse">
                                        <thead className="bg-[#3b5998] text-white">
                                            <tr>
                                                <th className="p-2 border border-gray-400 text-left w-1/2">वार्डचे नाव</th>
                                                <th className="p-2 border border-gray-400 text-left w-1/2">वार्डचे नाव</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr className="border border-gray-300">
                                                <td className="p-2 flex items-center gap-2">
                                                    <input type="checkbox" className="w-4 h-4" />
                                                </td>
                                                <td className="p-2">नाही</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                 </div>
                            </div>
                        )}
                    </div>

                    {/* Common Bottom Controls */}
                    <div className="bg-white border-t border-blue-300 p-4 mx-4 mb-4 rounded border">
                        <label className="flex items-center gap-2 cursor-pointer">
                             <input type="checkbox" className="w-5 h-5 border-blue-500 rounded text-blue-600 focus:ring-blue-500" />
                            <span className="text-gray-700 font-medium">कार्बन प्रती साठी</span>
                        </label>
                    </div>

                    {/* Register Button Footer */}
                    <div className="bg-[#1e429f] p-4 flex justify-center">
                        <button className="bg-[#10b981] hover:bg-[#059669] text-white px-8 py-2 rounded font-medium shadow-md transition-colors text-lg">
                            नमुना 10 रजिस्टर
                        </button>
                    </div>

                </div>
            </div>
             {/* Styles for animation */}
             <style jsx>{`
                @keyframes fadeInUp {
                    from { opacity: 0; transform: translateY(10px); }
                    to { opacity: 1; transform: translateY(0); }
                }
                .animate-fade-in-up {
                    animation: fadeInUp 0.3s ease-out forwards;
                }
            `}</style>
        </div>
    );
};

export default Namuna10Report;
